import type { ArcAngles } from './PieSlice.utils';

export const LINE_RADIAL_LENGTH = 16;
export const LINE_HORIZONTAL_LENGTH = 24;
export const POLYLINE_LABEL_WIDTH = 120;
const MIN_POLYLINE_LABEL_ANGLE = 0.3;

const POLYLINE_REFERENCE_RADIUS = 90;
const POLYLINE_MIN_SCALE = 0.4;
export const POLYLINE_HIDE_RADIUS = 40;

export const computePolylineScale = (radius: number): number =>
  Math.min(1, Math.max(POLYLINE_MIN_SCALE, radius / POLYLINE_REFERENCE_RADIUS));

export const computePolylinePoints = (angles: ArcAngles, sliceOuterRadius: number, adjustedRadius: number, scale = 1) => {
  const midAngle = (angles.startAngle + angles.endAngle) / 2;
  const cosA = Math.cos(midAngle - Math.PI / 2);
  const sinA = Math.sin(midAngle - Math.PI / 2);
  const scaledRadialLength = LINE_RADIAL_LENGTH * scale;
  const startX = cosA * sliceOuterRadius;
  const startY = sinA * sliceOuterRadius;
  const elbowX = cosA * (adjustedRadius + scaledRadialLength);
  const elbowY = sinA * (adjustedRadius + scaledRadialLength);
  return { startX, startY, elbowX, elbowY };
};

export const computePolylineLabelPosition = (
  angles: ArcAngles,
  labelRadius: number,
  selected: boolean,
  isHover: boolean,
  scale: number
) => {
  const midAngle = (angles.startAngle + angles.endAngle) / 2;
  const angleSpan = angles.endAngle - angles.startAngle;
  const cosA = Math.cos(midAngle - Math.PI / 2);
  const scaledRadialLength = LINE_RADIAL_LENGTH * scale;
  const scaledHorizontalLength = LINE_HORIZONTAL_LENGTH * scale;
  const elbowX = cosA * (labelRadius + scaledRadialLength);
  const elbowY = Math.sin(midAngle - Math.PI / 2) * (labelRadius + scaledRadialLength);
  const sign = cosA >= 0 ? 1 : -1;
  const labelX = elbowX + sign * scaledHorizontalLength;
  const offsetX = (sign * POLYLINE_LABEL_WIDTH) / 2;
  const showLabel = angleSpan >= MIN_POLYLINE_LABEL_ANGLE || selected || isHover;
  return { labelX, labelY: elbowY, offsetX, offsetY: 0, showLabel, labelRadius };
};
